

import UMUM from "../../library/umum.js";
export default {
    data() {
        return {

            UMUM: UMUM,

            list_data: [],

            status: 4,
            mdl_add: false,
            mdl_edit: false,
            mdl_delete: false,
            mdl_kembalikan: false,
            mdl_keterangan: false,
            mdl_lihat: false,
            mdl_catatan_admin: false,
            alert: false,
            simpan1: false,
            selectedItem: {},
            cari_value: "",
            page_first: 1,
            page_last: 1,
            page_limit: 8,
            total: 0,
            mdlAmbil: false,
            selectedProgram: {},
            jumlahAmbil: 0,
            mitra: {},
            ambilSemua: false,
            catatanAmbil: '',
            selectedPengajuanEdit: null,
            loadingEdit: false,

            tipe: null, // simpan tipe user


            form: {
                bidang_force_id: null,
                nama_csr: "",
                deskripsi: "",
                jumlah: null,
                satuan: "",
                nilai: null,
                tanggal_mulai: "",
                tanggal_selesai: "",
                kecamatan_id: null,
                desa_id: null,
                alamat: "",
                file_name: null  // 🔹 untuk file upload
            },

            mitra: {
                nama_perusahaan: '',
                email_perusahaan: '',
                telp_perusahaan: '',
                alamat_perusahaan: '',
                nama_pj: '',
                jabatan: '',
                email_pj: '',
                hp_pj: ''
            },
            list_bidang: [],
            list_kecamatan: [],
            list_kecamatan_master: [], // simpan data asli
            list_desa: [],
            list_desa_master: [],
            file_path: this.$store.state.url.URL_APP + "uploads/",


            filterku: {
                bidang_usaha_id: "",
                perusahaan_id: "",
                bidang_force_id: "",
                status_pengajuan: ""
            },


            list_bidang_filter: [],

            // hasil data yang difilter
            dataView: [],

            list_kecamatan_filter: [],
            list_desa_filter: [],

            statusOptions: [
                { label: 'Semua Status', value: '' },
                { label: 'Diproses', value: 1 },
                { label: 'Diterima', value: 2 },
                { label: 'Ditolak', value: 3 },
            ],

            list_perusahaan_filter: [],
            bidangOptions: [], // <- ubah dari computed ke data
            bidangUsahaOptions: [], // <- ubah dari computed ke data
            mdl_upload_eviden: false,
            uploadData: {
                id: null,        // simpan id program
                keterangan: '',
                file: null
            },
            list_data_bukti: [],

            columns_bukti: [
                { name: 'foto', label: 'Foto', field: 'file_name' },
                { name: 'keterangan', label: 'Keterangan', field: 'keterangan' },
                { name: 'aksi', label: 'Aksi', field: 'aksi' }
            ],

            mdl_lihat_eviden: false,
            selectedData: null, // ✅ tambahkan ini
            selectedItemEviden: {
                keterangan: '',
                files: []
            },


        }


    },

    computed: {
    // maxAllowed = program.jumlah_sisa + pengajuan.jumlah_ambil (karena pengajuan lama "memesan" jumlah lama)
    maxAllowed() {
        if (!this.selectedPengajuanEdit) return 0;
        // coba ambil field total kebutuhan: 'jumlah' atau fallback ke nama lain jika perlu
        const totalKebutuhan = Number(
            this.selectedPengajuanEdit.jumlah ??
            this.selectedPengajuanEdit.jumlah_kebutuhan ??
            this.selectedPengajuanEdit.total_kebutuhan ??
            0
        );
        // safety fallback: bila totalKebutuhan 0, gunakan sisa+old (agar tidak 0)
        if (totalKebutuhan > 0) return totalKebutuhan;
        const sisa = Number(this.selectedPengajuanEdit.jumlah_sisa ?? 0);
        const old = Number(this.selectedPengajuanEdit.jumlah_ambil ?? 0);
        return sisa + old;
    }
},


    methods: {

        openEdit(row) {
        // copy agar tidak merubah referensi asli
        this.selectedPengajuanEdit = Object.assign({}, row);

        // prioritas: jumlah_sisa (available) -> jumlah (total kebutuhan) -> jumlah_ambil (lama)
        const available = Number(row.jumlah_sisa ?? row.jumlah ?? row.jumlah_ambil ?? 0);

        // isi field jumlahAmbil langsung dengan jumlah tersedia
        this.jumlahAmbil = available;

        // isi catatan jika ada
        this.catatanAmbil = row.catatan_admin ?? '';

        // total kebutuhan (jika tersedia)
        const total = Number(row.jumlah ?? row.jumlah_kebutuhan ?? row.total_kebutuhan ?? 0);

        // jika jumlahAmbil sudah sama dengan total, set toggle ON
        this.ambilSemua = (total > 0 && this.jumlahAmbil === total);

        // buka modal edit
        this.mdl_edit = true;
    },

    onToggleSemua(val) {
        if (!this.selectedPengajuanEdit) return;

        const totalKebutuhan = Number(
            this.selectedPengajuanEdit.jumlah ??
            this.selectedPengajuanEdit.jumlah_kebutuhan ??
            this.selectedPengajuanEdit.total_kebutuhan ??
            0
        );

        if (val) {
            // set ke total kebutuhan (1000) — sesuai request Anda
            // input sudah memiliki :disable="ambilSemua", jadi otomatis tidak dapat diedit
            this.jumlahAmbil = totalKebutuhan > 0 ? totalKebutuhan : this.maxAllowed;
        } else {
            // kembalikan ke jumlah lama
            this.jumlahAmbil = Number(this.selectedPengajuanEdit.jumlah_ambil ?? 0);
        }
    },

    async submitEdit() {
        if (!this.selectedPengajuanEdit) return
        const newJumlah = Number(this.jumlahAmbil ?? 0)
        if (!newJumlah || newJumlah <= 0) {
            this.$q.notify({ type: 'negative', message: 'Jumlah harus minimal 1' })
            return
        }
        if (newJumlah > this.maxAllowed) {
            this.$q.notify({ type: 'negative', message: `Tidak boleh lebih dari ${this.maxAllowed}` })
            return
        }

        this.loadingEdit = true
        try {
            const base = this.$store.state.url.LIST_PENGAJUAN_FORCE || this.$store.state.url // fallback
            const endpoint = base.endsWith('/') ? base + 'editPengajuan' : base + '/editPengajuan'
            const token = localStorage.token || ''

            const payload = {
                id: this.selectedPengajuanEdit.id,
                jumlah_ambil: newJumlah,
            }

            const resp = await fetch(endpoint, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': 'kikensbatara ' + token
                },
                body: JSON.stringify(payload)
            })

            const resJson = await resp.json().catch(() => null)

            if (!resp.ok) {
                const msg = (resJson && resJson.message) ? resJson.message : `Server error (${resp.status})`
                this.$q.notify({ type: 'negative', message: msg })
                return
            }

            if (resJson && resJson.success) {
                this.$q.notify({ type: 'positive', message: resJson.message || 'Berhasil diubah' })
                this.getView();
                this.mdl_edit = false
            } else {
                const msg = (resJson && resJson.message) ? resJson.message : 'Gagal menyimpan perubahan'
                this.$q.notify({ type: 'negative', message: msg })
            }

        } catch (err) {
            console.error('submitEdit error', err)
            this.$q.notify({ type: 'negative', message: 'Kesalahan jaringan / server' })
        } finally {
            this.loadingEdit = false
        }
    },

    // Method untuk buka modal hapus
    openDeleteModal(item) {
        this.selectedItem = item;
        this.mdl_delete = true;
    },

    // Method untuk hapus data
    removeData: function () {
        if (!this.selectedItem.id) {
            this.Notify("ID data tidak ditemukan", "negative", "error_outline");
            return;
        }

        const base = this.$store.state.url.LIST_PENGAJUAN_FORCE || '';
        const url = base.replace(/\/?$/, '/') + 'removeData';

        const payload = { id: this.selectedItem.id };

        fetch(url, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": "kikensbatara " + localStorage.token
            },
            body: JSON.stringify(payload),
        })
            .then(async (res) => {
                const text = await res.text();
                let data; try { data = text ? JSON.parse(text) : {}; } catch { data = { message: text }; }
                if (!res.ok) throw new Error(data?.message || `HTTP ${res.status}`);
                return data;
            })
            .then((res_data) => {
                if (res_data?.success) {
                    this.Notify(res_data.message || 'Sukses Menghapus Data', 'positive', 'check_circle_outline');
                    this.getView();
                    this.mdl_delete = false;
                } else {
                    this.Notify(res_data?.message || 'Gagal Menghapus Data', 'warning', 'error');
                }
            })
            .catch((err) => {
                this.Notify('Gagal menghapus: ' + (err.message || 'Unknown error'), 'warning', 'error');
            });
    },

    // Method untuk edit data program (jika masih diperlukan)
    editData(item) {
        this.$router.push('/forceMajeure/edit/' + item.kegiatan_id);
    },

    // Method untuk hapus data program (jika masih diperlukan)
    hapusData: async function(id) {
        await UMUM.notifDelete();
        
        try {
            const res = await fetch(this.$store.state.url.LIST_PENGAJUAN_FORCE + "deleteProgram", {
                method: "DELETE",
                headers: {
                    "Content-Type": "application/json",
                    authorization: "kikensbatara " + localStorage.token
                },
                body: JSON.stringify({ id })
            });

            const data = await res.json();
            if (data.success) {
                this.Notify('Data berhasil dihapus', 'positive', 'check_circle_outline');
                this.getView(); // refresh list
            } else {
                this.Notify(data.message, 'negative', 'error_outline');
            }
        } catch (err) {
            console.error(err);
            this.Notify('Terjadi kesalahan server', 'negative', 'error_outline');
        }
    },

        async lihatEviden(item) {
            const res = await fetch(this.$store.state.url.LIST_PENGAJUAN_FORCE + 'getEviden?id=' + item.id, {
                headers: { authorization: "kikensbatara " + localStorage.token }
            });
            this.list_data_bukti = await res.json();
            this.mdl_lihat_eviden = true;
            this.selectedData = item; // ✅ simpan data yg dipilih
        },

        openUploadModal(item) {
            this.uploadData.id = item.id
            this.uploadData.keterangan = ''
            this.uploadData.file = null
            this.mdl_upload_eviden = true
            this.getListBukti()
        },

        async getListBukti() {
            if (!this.uploadData.id) return
            const res = await fetch(
                this.$store.state.url.LIST_PENGAJUAN_FORCE + 'getEviden?id=' + this.uploadData.id,
                { headers: { authorization: 'kikensbatara ' + localStorage.token } }
            )
            const data = await res.json()
            this.list_data_bukti = data
        },

        async hapusBukti(id) {
            if (!confirm("Yakin hapus bukti ini?")) return
            await fetch(this.$store.state.url.LIST_PENGAJUAN_FORCE + 'deleteEviden?id=' + id, { method: 'DELETE' })
            this.getListBukti()
        },

        resetUploadModal() {
            this.uploadData.keterangan = ''
            this.uploadData.file = null
        },

        async submitUploadEviden() {
            if (!this.uploadData.keterangan) {
                this.Notify('Keterangan harus diisi', 'negative', 'warning')
                return
            }

            if (!this.uploadData.file) {
                this.Notify('Pilih 1 foto terlebih dahulu', 'negative', 'warning')
                return
            }

            const formData = new FormData()
            formData.append('id', this.uploadData.id)
            formData.append('keterangan', this.uploadData.keterangan)
            formData.append('file', this.uploadData.file)  // 🔥 harus "file"

            try {
                const res = await fetch(this.$store.state.url.LIST_PENGAJUAN_FORCE + 'uploadEviden', {
                    method: 'POST',
                    headers: {
                        authorization: 'kikensbatara ' + localStorage.token
                    },
                    body: formData
                })

                const data = await res.json()
                if (data.success) {
                    this.Notify('Bukti berhasil diupload', 'positive', 'check_circle_outline')
                    this.resetUploadModal()
                    this.mdl_upload_eviden = false
                    this.getView() // refresh list
                } else {
                    this.Notify(data.message, 'negative', 'error_outline')
                }
            } catch (err) {
                console.error(err)
                this.Notify('Terjadi kesalahan server', 'negative', 'error_outline')
            }
        },
        previewFile(row) {
            window.open(this.fileBaseUrl + row.file_name, '_blank')
        },



        hapusBukti(id) {
            if (!confirm("Yakin hapus bukti ini?")) return;

            fetch(this.$store.state.url.LIST_PENGAJUAN_FORCE + "removeEviden", {
                method: "POST",
                headers: {
                    "content-type": "application/json",
                    authorization: "kikensbatara " + localStorage.token
                },
                body: JSON.stringify({ id })
            })
                .then(res => res.json())
                .then(res_data => {
                    if (res_data.success) {
                        this.Notify("Bukti berhasil dihapus", "positive", "check_circle_outline");
                        this.getListBukti();
                    } else {
                        this.Notify(res_data.message || "Gagal hapus bukti", "negative", "error");
                    }
                })
                .catch(err => {
                    this.Notify("Error: " + err.message, "warning", "error");
                });
        },
        selesaikanProgram: async function (id) {
            try {
                // konfirmasi dulu
                this.mdl_lihat_eviden = false;
                await UMUM.notifApprove();

                const res = await fetch(this.$store.state.url.LIST_PENGAJUAN_FORCE + "selesaikanProgram", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        authorization: "kikensbatara " + localStorage.token
                    },
                    body: JSON.stringify({ id })
                });

                const result = await res.json();
                if (result.success) {
                    this.Notify("Program berhasil diselesaikan", "positive", "check_circle_outline");
                    this.mdl_lihat_eviden = false;
                    this.getView(); // refresh tabel utama
                } else {
                    this.Notify(result.message || "Gagal menyelesaikan program", "negative", "error_outline");
                }
            } catch (err) {
                // kalau user batal di notifApprove, dia juga bakal masuk ke sini
                console.error(err);
                this.Notify("Error: " + err.message, "negative", "error");
            }
        },

        downloadFile(fileName) {
            if (fileName) {
                window.open(this.file_path + fileName, "_blank");
            }
        },

        lihatKeterangan: function (item) {
            this.selectedItem = { ...item };
            this.mdl_keterangan = true; // buka modal keterangan
        },

        tolakPengajuan: async function (id) {
            // Cari data sesuai id dan simpan di selectedItem
            const item = this.list_data.find(d => d.id === id);
            if (!item) return;

            this.selectedItem = { ...item, catatan_admin: '' };
            this.mdl_catatan_admin = true; // buka modal
        },


        // Tombol Evaluasi di modal
        submitTolak: async function () {
            if (!this.selectedItem.catatan_admin) {
                this.Notify('Catatan harus diisi', 'negative', 'warning');
                return;
            }

            try {
                const res = await fetch(this.$store.state.url.LIST_PENGAJUAN_FORCE + "tolakPengajuan", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        authorization: "kikensbatara " + localStorage.token
                    },
                    body: JSON.stringify({
                        id: this.selectedItem.id,
                        catatan_admin: this.selectedItem.catatan_admin
                    })
                });

                const data = await res.json();

                if (data.success) {
                    this.Notify('Pengajuan ditolak', 'negative', 'cancel');
                    this.getView(); // refresh list
                    this.mdl_catatan_admin = false; // tutup modal
                } else {
                    this.Notify(data.message, 'negative', 'error_outline');
                }

            } catch (err) {
                console.error(err);
                this.Notify('Terjadi kesalahan server', 'negative', 'error_outline');
            }
        },

        selectData(item) {
            this.selectedItem = item;
            this.mdl_lihat = true; // buka modal
        },


        onStatusChange(val) {
            this.getView()
        },


        onChangeBidang(val) {


            this.getView(); // refresh data
        },

        formatRupiah(value) {
            if (value == null) return "-";
            return new Intl.NumberFormat('id-ID', {
                style: 'currency',
                currency: 'IDR',
                minimumFractionDigits: 0,
                maximumFractionDigits: 0
            }).format(value);
        },


        getBidang() {
            fetch(this.$store.state.url.URL_DM_BID + "force", {
                headers: {
                    authorization: "kikensbatara " + localStorage.token
                }
            })
                .then(res => res.json())
                .then(res_data => {
                    this.list_bidang = res_data
                })
        },
        getMitra(userId) {
            fetch(this.$store.state.url.KEGIATAN_CSR + "mitra/" + userId, {
                method: "GET",
                headers: {
                    authorization: "kikensbatara " + localStorage.token
                }
            })
                .then(res => res.json())
                .then(res_data => {
                    if (res_data.success) {
                        this.mitra = res_data.data
                    } else {
                        this.Notify("Gagal mengambil data mitra", "negative", "error_outline")
                    }
                })
                .catch(err => {
                    console.error("❌ Error:", err)
                    this.Notify("Terjadi kesalahan server", "negative", "error_outline")
                })
        },




        // ambil data utama
        getView() {
            this.$store.commit("shoWLoading");
            fetch(this.$store.state.url.LIST_PENGAJUAN_FORCE + "view", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    authorization: "kikensbatara " + localStorage.token
                },
                body: JSON.stringify({
                    status_pengajuan: this.filterku.status_pengajuan,
                    bidang_usaha_id: this.filterku.bidang_usaha_id,   // 🔎 filter perusahaan
                    perusahaan_id: this.filterku.perusahaan_id,   // 🔎 filter perusahaan
                    bidang_force_id: this.filterku.bidang_force_id,       // 🔎 filter bidang CSR
                    cari_value: this.cari_value,
                    data_ke: this.page_first,
                    page_limit: this.page_limit,
                    tipe: this.tipe
                })
            })
                .then(res => res.json())
                .then(res_data => {
                    if (res_data.success) {
                        this.list_data = res_data.data;
                        this.total = res_data.total || res_data.data.length;
                        this.page_last = Math.ceil(this.total / this.page_limit);
                    }
                    this.$store.commit("hideLoading");
                })
                .catch(err => {
                    console.error("❌ Error getView:", err);
                    this.$store.commit("hideLoading");
                });
        },


        approvePengajuan: async function (id) {
            await UMUM.notifApprove();
            fetch(this.$store.state.url.LIST_PENGAJUAN_FORCE + "approvePengajuan", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    authorization: "kikensbatara " + localStorage.token
                },
                body: JSON.stringify({ id }) // kirim id saja
            })
                .then(res => res.json())
                .then(res_data => {
                    if (res_data.success) {
                        this.Notify('Pengajuan disetujui', 'positive', 'check_circle_outline');
                        this.getView(); // refresh list
                    } else {
                        this.Notify(res_data.message, 'negative', 'error_outline');
                    }
                })
                .catch(err => console.error(err));
        },



        getBidangFilter() {
            fetch(this.$store.state.url.URL_DM_BID + "force", {
                headers: {
                    authorization: "kikensbatara " + localStorage.token
                }
            })
                .then(res => res.json())
                .then(res_data => {
                    this.bidangOptions = [
                        { id: "", uraian: "-- SEMUA BIDANG --" },
                        ...res_data.map(b => ({
                            ...b,
                            id: b.id.toString()  // pastikan tipe sama dengan v-model
                        }))
                    ];
                })
        },


        //   ================ FILTER BIDANG USAHA DAN PERUSAHAAN ==================
        getBidangUsahaFilter() {
            fetch(this.$store.state.url.DATA_MITRA + "bidang", {
                headers: { authorization: "kikensbatara " + localStorage.token }
            })
                .then(res => res.json())
                .then(res_data => {
                    this.bidangUsahaOptions = [
                        { id: "", uraian: "-- SEMUA BIDANG USAHA --" },
                        ...res_data
                    ]
                })
                .catch(err => console.error("❌ Error fetch bidang:", err))
        },

        onChangeBidangUsahaFilter(val) {
            this.filterku.bidang_usaha_id = val
            this.filterku.perusahaan_id = ""
            this.getPerusahaanFilter()
            this.getView()
        },

        getPerusahaanFilter() {
            if (!this.filterku.bidang_usaha_id) {
                this.list_perusahaan_filter = []
                return
            }

            fetch(this.$store.state.url.DATA_MITRA + "byBidang", {
                method: "POST",
                headers: {
                    "content-type": "application/json",
                    authorization: "kikensbatara " + localStorage.token
                },
                body: JSON.stringify({
                    bidang_usaha_id: this.filterku.bidang_usaha_id
                })
            })
                .then(res => res.json())
                .then(res_data => {
                    this.list_perusahaan_filter = res_data
                })
                .catch(err => {
                    console.error("❌ Error fetch perusahaan:", err)
                })
        },

        onChangePerusahaanFilter(val) {
            this.filterku.perusahaan_id = val
            this.getView()
        },

        //   ================ FILTER BIDANG USAHA DAN PERUSAHAAN ==================



        simulateProgress(number) {
            // we set loading state
            this[`simpan${number}`] = true
            // simulate a delay
            setTimeout(() => {
                // we're done, we reset loading state
                this[`simpan${number}`] = false
            }, 3000)
        },

        Notify: function (message, positive, icon) {
            this.$q.notify({
                message: message,
                color: positive,
                icon: icon,
                position: 'top',
                timeout: 500,
            })
        },


        btn_prev() {
            if (this.page_first > 1) this.page_first--;
            this.getView();
        },

        btn_next() {
            if (this.page_first < this.page_last) this.page_first++;
            this.getView();
        },

        cari_data() {
            this.page_first = 1;
            this.getView();
        },

        indexing(index) {
            return ((this.page_first - 1) * this.page_limit) + index;
        },



    },
    mounted() {

        const get_profile = JSON.parse(localStorage.profile);
        this.tipe = Number(get_profile.profile.db_csrkonsel); // ambil db_csrkonsel


        // simpan data mitra (kalau yang login memang mitra)
        this.mitra = {
            id: get_profile._id,
            nama: get_profile.profile.nama,
            username: get_profile.username
        }


        // jalankan ketika halaman pertama kali dibuka
        this.getView();
        // this.getDesaFilter();
        this.getBidang();
        this.getBidangFilter();
        this.getBidangUsahaFilter();
        // this.getSubBidangFilter();
    }
}
